import { Upload, WithMongooseProps } from '@runelab/odin-common'
import { ChatResponseModeEnum, ChatRoleEnum } from 'types/chat'
import { ChatAttachment } from 'types/chat-attachment'
import { User } from 'types/user'

export enum MessageTypeEnum {
  TEXT = 'TEXT',
  AUDIO = 'AUDIO',
  IMAGE = 'IMAGE',
  VIDEO = 'VIDEO',
  FILE = 'FILE',
  OTHER = 'OTHER',
  SYSTEM = 'SYSTEM',
}

export enum SystemEventTypeEnum {
  TICKET_CLOSED = 'TICKET_CLOSED',
  TICKET_REOPENED = 'TICKET_REOPENED',
}

export enum FeedbackEnum {
  GOOD = 'good',
  BAD = 'bad',
}

export enum AgentActionStatusEnum {
  PENDING = 'pending',
  ACCEPTED = 'accepted',
  REJECTED = 'rejected',
}

export enum MessageSourceEnum {
  localBotResponse = 'localBotResponse', // local response such as (welcome message, bot typing, etc)
  remote = 'remote', // remote response such as (operator response, bot response)
  user = 'user', // user questions
}

export type CitationSource = {
  id: string
  name: string
  type: string
  url: string | null
  pageUrl?: string | null
  page?: number | null
  imageUrl?: string
  // Agentic tool sources (type: 'tool'): the call's arguments, so the user can
  // inspect/reproduce it. For the Qlik agent these are { appId, expression }.
  toolName?: string
  params?: Record<string, unknown>
}

type OdinChatMessage = WithMongooseProps<{
  senderId?: string
  sender?: User
  chatId: string
  timestamp: number
  feedback?: FeedbackEnum
  isSourceAdded?: boolean
  message: string
  type: MessageTypeEnum
  chatResponseMode: ChatResponseModeEnum
  chatSenderEmail?: string
  // Operator attachments
  operatorAttachmentIds?: string[]
  operatorAttachments?: Upload[]
  // Bot-chat attachments
  attachmentIds?: string[]
  attachments?: ChatAttachment[]
  chatSenderRole: ChatRoleEnum
  agentRunId?: string
  agentActionStatus?: AgentActionStatusEnum
  // Set only when type === SYSTEM
  systemEventType?: SystemEventTypeEnum
}>

export type ChatMessage = OdinChatMessage & {
  isWelcomeMessage?: boolean
  messageSource?: MessageSourceEnum
}
